module.exports = __webpack_public_path__ + "static/favicon-f36eeb364887c8c1de3c080360839ea3.ico";